import React, { useState } from 'react'
import { useEffect } from 'react'
import { getTopic, createTopic, deleteTopic, updateTopic } from '../../../services/admin'
import Pagination from '../../../components/tablePagination';
import Checkbox from '../Subcomponents/checkbox';
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from 'moment';
import addNewTopic from './addnewtopic.js';
import "./topic.css"
import { toast } from "react-toastify";

export default function Topic() {
    const [list, setList] = useState([]);
    const [totalcount, setTotalCount] = useState(0);
    const [timezonePage, settimezonePage] = useState(1);
    const [timezonerowsPerPage, settimezonerowsPerPage] = useState(10);
    const navigate = useNavigate();
    const [topic, setTopic] = useState("");
    const [status, setStatus] = useState("Add");
    const [topicId, setTopicId] = useState("");



    useEffect(() => {
        let info = {
            page: timezonePage, rowsPerPage: timezonerowsPerPage
        }
        getTimes(info);
    }, [])

    const getTimes = (info) => {

        getTopic(info).then((data) => {
            if (data.data.status) {
                setList(data.data.data.data)
                setTotalCount(data.data.data.total)
                console.log(data.data.data, "data")
            }
        }).catch(() => { })
    }
    const getPaginationData = (data) => {
        let info = {
            page: data.page, rowsPerPage: data.rowsPerPage
        }
        getTimes(info);
    }
    const navigateEdit = (e, id) => {
        window.renderFirst = false;
        if (e.target.className == "capitalizeMedium") {
            navigate(`/edit/${id.user_id}`);
        }
    };
    const addTopic = () => {
        setStatus("Add")
    }
    const editTopic = (id, topicVal) => {
        setTopic(topicVal)
        setTopicId(id)
        setStatus("Edit")
        window.loadModal2("#topicModal", "show");
    }
    const deleteTopicData = (id) => {
        let body = {
            id: id
        }
        deleteTopic(body).then((data) => {
            if (data.data.status) {
                getTimes({ page: timezonePage, rowsPerPage: timezonerowsPerPage });
                window.loadModal2("#topicModal", "hide");
                toast.success(data.data.message, {
                    position: "top-center",
                  });
            }else{
                toast.error(data.data.message, { position: "top-center" });
            }
        }).catch(() => { 
            toast.error("Something went wrong", { position: "top-center" });
         })
    }
    const submitHandler = () => {
        let body = {
            topic: topic,
        }
        createTopic(body).then((data) => {
            if (data.data.status) {
                setTopic("");
                getTimes({ page: timezonePage, rowsPerPage: timezonerowsPerPage });
                window.loadModal2("#topicModal", "hide");
                toast.success(data.data.message, {
                    position: "top-center",
                  });
            }else{
                toast.error(data.data.message, { position: "top-center" });
            }
        }).catch(() => { 
            toast.error("Something went wrong", { position: "top-center" }); 
        })
    };

    const submitEdit = () => {
        let body = {
            topic: topic,
            id: topicId
        }
        updateTopic(body,topicId)
            .then((data) => {
                if (data.data.status) {
                    setTopic("");
                    setTopicId("");
                    getTimes({ page: timezonePage, rowsPerPage: timezonerowsPerPage });
                    window.loadModal2("#topicModal", "hide");
                    toast.success(data.data.message, {
                                position: "top-center",
                            });
                }else{
                    toast.error(data.data.message, { position: "top-center" });
                }
            })
        .catch(() => {
            toast.error("Something went wrong", { position: "top-center" });
        });
    }
    const enterHandler = () => {
        if (topic.trim() === "") {
            toast.error("Please enter a topic", { position: "top-center" });
            return;
        }
        if (status == "Add") {
            submitHandler();
        } else {
            submitEdit();
        }
        // setTopic("");
        // setTopicId("");
        // getTimes({ page: timezonePage, rowsPerPage: timezonerowsPerPage });
        // window.loadModal2("#topicModal", "hide");
        // toast.success("Topic updated successfully", {
        //     position: "top-center",
        // });
        // setStatus("Add")
        // setTopic("");
        // setTopicId("");  
    }
    return (

        <>
            <div className="d-flex">
                <a className="export-btn" type="button"
                    data-toggle="modal"
                    data-target="#topicModal"
                    onClick={(e) => addTopic()}
                >
                    Add Topic
                </a>
            </div>
            <div className="table-box-medium">
                <table className="caseTable">
                    <tbody>
                        <tr className="dark">

                            <th>
                                {" "}
                                <div className="d-flex align-items-center">
                                    {" "}
                                    <span className="scren-name">ID</span>{" "}
                                    {/* <Sorting callApi={filterListMediums} /> */}
                                </div>
                            </th>

                            <th>Topic</th>
                            <th>Created</th>
                            <th>Action</th>
                        </tr>
                        {list.length > 0 ? (
                            list.map((topic) => (
                                <tr
                                    onClick={(e) => navigateEdit(e, topic)}
                                    className="innr pointer"
                                >


                                    <td className='capitalizeMedium'>{
                                        topic.id
                                    }
                                    </td>
                                    <td>
                                        {topic.topic}
                                    </td>
                                    <td>
                                        {topic.craeted}
                                    </td>
                                    <td>
                                    <div>
                                       
                                            <a
                                                type="button"
                                                data-toggle="modal"
                                                data-target="#topicModal"
                                                 className="export-btn topic-btn"
                                                
                                                onClick={(e) => editTopic(topic.id, topic.topic)}
                                            >
                                               Update
                                            </a>
                                            &nbsp; 
                                      
                                            <button
                                                onClick={() =>
                                                    deleteTopicData(
                                                        topic.id
                                                    )
                                                }
                                                className="register-medium-confirnation model-close-btn"
                                            >
                                                Delete
                                            </button>
                                        </div>
                                        
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center">
                                    No Records Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


                {/* popup for add Topic  */}

                {/* end topic */}
            </div>
            <div className="popup-accordion">
                <div class="modal fade" id="topicModal" role="dialog">
                    <div class="modal-dialog h-unset modal-dialog-preview">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">
                                    &times;
                                </button>
                            </div>
                            <div class="modal-body">
                                <h4> {status == "Edit" ? "Edit" : "Add"} Topic</h4>
                                <form onSubmit={(e) => e.preventDefault()}>
                                    <div className="fild-popup-row">
                                        <label>Topic</label>
                                        <input

                                            value={topic}
                                            onChange={(e) => setTopic(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                  e.preventDefault(); // Prevent form submission / reload
                                                  enterHandler();    // Your function
                                                }
                                              }}
                                            type="text"
                                            id="topic"
                                            name="topic"
                                            placeholder=""
                                        ></input>
                                    </div>
                                    <div className="cancel-btn-sumbit">
                                        <button
                                            type="button"
                                            data-dismiss="modal"
                                            className="cancel-tn"
                                        >
                                            Cancel
                                        </button>
                                        {status == "Add" ?
                                            <button
                                                onClick={submitHandler}
                                                type="button"
                                                // data-dismiss="modal"
                                                className="sumbit-tn"
                                            >
                                                Add
                                            </button>
                                            :
                                            <button
                                                onClick={submitEdit}
                                                type="button"
                                                // data-dismiss="modal"
                                                className="sumbit-tn"
                                            >
                                                Update
                                            </button>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Pagination
                rowsPerPageOptions={[5, 10, 25]}
                count={totalcount}
                activeTab={"admindetectedTimezones"}
                timezonePage={timezonePage}
                timezonerowsPerPage={timezonerowsPerPage}
                getPaginationData={getPaginationData}
            />


            {/* <div ><PaginatedItems itemsPerPage={5}/></div> */}
            {/* <addNewTopic
                        /> */}
        </>
    )
}
